import * as React from 'react';
import { NotificationsComponent } from './NotificationsComponent';

type INotificationsTopRight = {};

export function NotificationsTopRight(props: INotificationsTopRight) {
  return <NotificationsComponent />;
}
